import React from 'react';
import { ScrollView } from 'react-native';

import { Card, VFScreen } from '@vfgroup-oneplatform/foundation/Components';
import SpinnerOverlay from '@vfgroup-oneplatform/foundation/Components/SpinnerOverlay';
import { withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { dateCurrencyFromatter } from '@vfgroup-oneplatform/foundation/Utils/dateCurrencyFormate';
import moment from 'moment';
import PropTypes from 'prop-types';

import ButtonsSection from '../CreateInstalmentMainScreen/components/ButtonsSection/ButtonsSection';

import Body from './components/Body/Body';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import InstalmentSuccessModal from './components/InstalmentSuccessModal/InstalmentSuccessModal';
import SectionTitleDescription from './components/SectionTitleDescription/SectionTitleDescription';
import style from './ReviewInstalmentPlanStyle';

class ReviewInstalmentPlan extends React.Component {
  constructor(props) {
    super(props);
    this.nextMonth = '';
    this.dayOfMonthlyBill = '';
    this.state = {
      isShowSuccessModal: false,
    };
  }
  getVFScreenProps = () => {
    const { onClose, onBack, theme } = this.props;
    return {
      title: 'billing_setup_installment_plan_screen_title',
      onClose: onClose,
      closeButtonTestID: '',
      showBack: true,
      onBack: onBack,
      headerStyle: style.headerStyle(theme),
    };
  };
  getHeaderProps = () => {
    const {
      instalmentData: { instalmentDateUnit, instalmentPrice },
    } = this.props;
    return {
      title: 'billing_review_installment_plan_details_title',
      dateUnit: instalmentDateUnit,
      price: instalmentPrice,
    };
  };
  getBodyProps = () => {
    const {
      instalmentData: { numOfInstalmentPlan, fee },
    } = this.props;
    return {
      feeTitle: 'billing_review_installment_plan_fee_title',
      feeValue: fee,
      numOfInstalmentTitle: 'billing_review_installment_plan_number_of_installments_title',
      numOfInstalmentValue: numOfInstalmentPlan,
    };
  };
  getFooterProps = () => {
    const {
      instalmentData: { total },
    } = this.props;
    return {
      totalTitle: 'billing_review_installment_plan_total_title',
      totalValue: total,
    };
  };
  getFirstDescriptionProps = () => {
    const {
      instalmentData: { dayOfMonthlyBill },
      Images,
    } = this.props;

    return {
      title: 'billing_review_installment_plan_payment_date_title',
      description: {
        key: 'billing_review_installment_plan_payment_date_desc',
        placeholder: [dayOfMonthlyBill],
      },
      iconName: Images.icInfoCircle,
    };
  };
  getSecondDescriptionProps = () => {
    const {
      instalmentData: { dayOfMonthlyBill },
      Images,
    } = this.props;

    return {
      title: 'billing_review_installment_plan_first_payment_date_title',
      description: {
        key: this.getNextPaymentMonth(dayOfMonthlyBill),
        placeholder: [],
      },
      iconName: Images.icInfoCircle,
    };
  };
  getButtonSectionProps = () => {
    const { theme, onPressPrimary, onPressSecondary, instalmentData } = this.props;
    return {
      primaryButtonTitle: 'billing_review_installment_plan_primary_button_title',
      secondaryButtonTitle: 'billing_review_installment_plan_secondary_button_title',
      theme: theme,
      containerStyle: style.buttonsSectionContainer,
      onPressPrimary: () =>
        onPressPrimary({
          ...instalmentData,
          dayOfMonthlyBill: this.dayOfMonthlyBill,
          nextMonth: this.nextMonth,
        }),
      onPressSecondary,
    };
  };
  getNextPaymentMonth = dayOfMonthlyBill => {
    const { dateFormats } = dateCurrencyFromatter;
    const nextMonth = dateCurrencyFromatter.dateTransformer(
      moment().add(1, 'months'),
      dateFormats.monthName,
    );
    const nextMonthDays = moment().add(1, 'months').daysInMonth();
    const day = parseInt(dayOfMonthlyBill.substring(0, dayOfMonthlyBill.length - 2), 10);
    this.dayOfMonthlyBill = dayOfMonthlyBill;
    this.nextMonth = nextMonth;
    if (day > nextMonthDays) {
      this.dayOfMonthlyBill = moment().localeData().ordinal(1);
      return `${this.dayOfMonthlyBill} ${nextMonth}`;
    }

    return `${this.dayOfMonthlyBill} ${nextMonth}`;
  };
  showSuccessModal = () => {
    const { isConfirmedSuccess } = this.props;
    if (isConfirmedSuccess) {
      this.setState({ isShowSuccessModal: true });
    }
  };
  renderLoadingOverLay = () => {
    const { isLoading: isVisible } = this.props;
    return (
      <SpinnerOverlay
        isVisible={isVisible}
        autoPlay
        lottieStyle={style.lottieStyle}
        onModalHide={this.showSuccessModal}
      />
    );
  };

  renderSuccessModal = () => {
    const { onPrimaryModalPress } = this.props;
    const { isShowSuccessModal } = this.state;
    return (
      isShowSuccessModal && (
        <InstalmentSuccessModal
          dayOfMonthlyBill={this.dayOfMonthlyBill}
          nextMonth={this.nextMonth}
          onPressPrimary={onPrimaryModalPress}
        />
      )
    );
  };
  renderFirstCard = () => {
    const { theme } = this.props;
    return (
      <Card style={[style.card(theme), style.firstCardStyle]}>
        <Header {...this.getHeaderProps()} />
        <Body {...this.getBodyProps()} />
        <Footer {...this.getFooterProps()} />
      </Card>
    );
  };
  renderSecondCard = () => {
    const { theme } = this.props;
    return (
      <Card style={[style.card(theme), style.secondCardStyle]}>
        <SectionTitleDescription {...this.getFirstDescriptionProps()} />
        <SectionTitleDescription {...this.getSecondDescriptionProps()} />
      </Card>
    );
  };
  render() {
    return (
      <VFScreen {...this.getVFScreenProps()}>
        <ScrollView
          style={style.containerStyle}
          contentContainerStyle={style.contentContainerStyle}
        >
          {this.renderLoadingOverLay()}
          {this.renderSuccessModal()}
          {this.renderFirstCard()}
          {this.renderSecondCard()}
          <ButtonsSection {...this.getButtonSectionProps()} />
        </ScrollView>
      </VFScreen>
    );
  }
}
ReviewInstalmentPlan.propTypes = {
  onClose: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }).isRequired,
  isLoading: PropTypes.bool,
  onPressPrimary: PropTypes.func.isRequired,
  onPressSecondary: PropTypes.func,
  onPrimaryModalPress: PropTypes.func.isRequired,
  isConfirmedSuccess: PropTypes.bool,
  Images: PropTypes.shape().isRequired,
  instalmentData: PropTypes.shape({
    total: PropTypes.string.isRequired,
    dayOfMonthlyBill: PropTypes.string.isRequired,
    numOfInstalmentPlan: PropTypes.number.isRequired,
    instalmentPrice: PropTypes.string.isRequired,
    instalmentDateUnit: PropTypes.string.isRequired,
    fee: PropTypes.string.isRequired,
  }).isRequired,
};
export { ReviewInstalmentPlan };
export default withTheme(ReviewInstalmentPlan);
